var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaCardLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 8,
    viewBox: "0 0 26 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85641 0.141272L6.61334 7.87885H4.49749L2.90156 1.70391C2.80467 1.32357 2.72043 1.18423 2.42576 1.024C1.94466 0.762998 1.15018 0.518127 0.451172 0.366146L0.49865 0.141272H3.90453C4.33867 0.141272 4.72894 0.430267 4.82751 0.930202L5.67037 5.40756L7.75345 0.141143H9.85641V0.141272ZM18.1467 5.35273C18.1552 3.31054 15.3228 3.19804 15.3423 2.28577C15.3483 2.00813 15.6127 1.71294 16.1913 1.6376C16.4781 1.60005 17.2684 1.57141 18.1646 1.98387L18.5162 0.343053C18.0346 0.168236 17.4149 0 16.6439 0C14.6655 0 13.2731 1.05174 13.2614 2.55773C13.2486 3.67165 14.2552 4.29325 15.0135 4.6634C15.7937 5.04245 16.0555 5.28603 16.0525 5.62508C16.047 6.14411 15.4303 6.37324 14.854 6.38227C13.8479 6.39775 13.2641 6.11005 12.7987 5.89369L12.4359 7.58883C12.9036 7.80338 13.7669 7.99058 14.6619 8C16.7647 8 18.1402 6.96129 18.1467 5.35273ZM23.371 7.87898H25.2223L23.6064 0.141272H21.8977C21.5135 0.141272 21.1894 0.364985 21.0459 0.708941L18.0423 7.87885H20.1441L20.5613 6.72313H23.1294L23.371 7.87885V7.87898ZM21.1377 5.1374L22.1912 2.23223L22.7976 5.1374H21.1377ZM12.7163 0.141272L11.0612 7.87885H9.05961L10.7154 0.141272H12.7163Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCardLogo);
export default __webpack_public_path__ + "static/media/visa-card-logo.c26574c4cc7a247297937fc015e08115.svg";
export { ForwardRef as ReactComponent };